import { usePermissions } from "@/contexts/usePermissions";
import { useIntegration } from "@/hooks/useIntegrations";
import { usePageTitle } from "@/hooks/usePageTitle";
import { Navigate, useNavigate, useParams } from "react-router";

import { useFactoriesLayout } from "../layout/factoriesLayoutContext";
import { factoryHomePath, factoryLineDetailPath, firstFactoryLineId } from "../lib/factoryPagePaths";
import { RiskScoreSetupDialog } from "./RiskScoreSetupDialog";
import { RISK_SCORE_SETUP_COPY } from "./riskScoreSetupCopy";

export function RiskScoreSetupPage() {
  const { organizationId, factoryId, routeSegment, factory } = useFactoriesLayout();
  const { canAct } = usePermissions();
  const { lineId } = useParams<{ lineId?: string }>();
  const navigate = useNavigate();

  usePageTitle([RISK_SCORE_SETUP_COPY.pageTitle, factory?.name ?? "Workspace"]);

  const boardHref = factoryHomePath(organizationId, routeSegment, firstFactoryLineId(factory));
  const line = factory?.lines?.find((entry) => entry.id === lineId);
  const returnHref = line?.id ? factoryLineDetailPath(organizationId, routeSegment, line.id) : boardHref;
  const githubIntegrationId = factory?.onboarding?.vcsIntegrationId?.trim() ?? "";
  const githubIntegration = useIntegration(organizationId, githubIntegrationId);
  const githubInstallationName = githubIntegration.data?.metadata?.name?.trim() ?? "";

  if (!canAct("factories", "update") || !lineId || (factory && !line)) {
    return <Navigate to={boardHref} replace />;
  }

  return (
    <div className="h-full min-h-0" data-testid="risk-score-setup-page">
      <RiskScoreSetupDialog
        organizationId={organizationId}
        factoryId={factoryId}
        githubIntegrationId={githubIntegrationId}
        githubInstallationName={githubInstallationName}
        appRepository={factory?.onboarding?.appRepository?.trim() ?? ""}
        backlogRepository={factory?.onboarding?.backlogRepository?.trim() ?? ""}
        defaultBranch={factory?.onboarding?.defaultBranch?.trim() ?? ""}
        onClose={() => navigate(returnHref)}
        onCreated={() => navigate(returnHref)}
      />
    </div>
  );
}
